import React, { useEffect } from "react";
import { useNavigate, NavLink, Outlet } from "react-router-dom";
import "../../styles/Dashboard.css";

// The frame both dashboards sit in: a titled section nav on the left, the
// current section on the right.
//
// Shared rather than copied, because the two sides of the marketplace should
// look like two views of one product rather than two products. A duplicated
// shell drifts -- one gets a spacing fix, the other does not, and six months
// later the broadcaster and advertiser dashboards are visibly different
// software.
//
// The section is the ROUTE, never local state. That was a real bug on the
// broadcaster side: the shell held `section` in useState and rendered both the
// chosen panel and an <Outlet/>, so /vendor-dashboard/device/3 showed the
// device list with the device page underneath it, and back, forward, refresh
// and every bookmark landed on the first tab.

export default function DashboardShell({ title, tabs, requires }) {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/");
            return;
        }
        // Gated on holding the PROFILE ID, not on the active role. An account
        // can be both a broadcaster and an advertiser, and which dashboard it
        // is looking at is a preference -- not a statement about what it is
        // allowed to open. Checking `role` here would lock a dual-role account
        // out of one of its own dashboards depending on which one it happened
        // to land on at login.
        //
        // This is a convenience redirect, not a security boundary: every API
        // call behind it is authorised server-side from the signed token.
        if (requires && !localStorage.getItem(requires)) {
            navigate("/");
        }
    }, [navigate, requires]);

    const tabClass = ({ isActive }) => "dash__tab" + (isActive ? " is-active" : "");

    return (
        <div className="dash">
            <nav className="dash__nav" aria-label="Dashboard sections">
                <p className="dash__nav-title">{title}</p>
                {tabs.map((t) => (
                    <NavLink key={t.to} to={t.to} className={tabClass} end>
                        {t.label}
                    </NavLink>
                ))}
            </nav>

            <div className="dash__main">
                <Outlet />
            </div>
        </div>
    );
}
